/* src/app/modules/finanzas/prestamos/prestamos.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul,
li {
  list-style-type: none;
}
li {
  margin: auto 10px;
}
th,
td {
  padding: 5px;
  vertical-align: top;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
}
.pdf-container {
  height: 80vh;
}
.spacer {
  flex: 1 1 auto;
}
.flex-container.investment-form-container .second-column {
  width: 40%;
}
.flex-container.investment-form-container .first-column .imageFile {
  max-width: 70%;
  max-height: none;
  margin: 0 auto;
}
.pdf-image-file {
  max-width: 80% !important;
}
@media (max-width: 1200px) {
  .flex-container.investment-form-container .first-column .imageFile {
    max-width: 100%;
  }
  .pdf-image-file {
    max-width: 100% !important;
  }
}
@media (max-width: 991px) {
  .flex-container.investment-form-container .second-column {
    width: 30%;
  }
}
@media (max-width: 767px) {
  .flex-container.investment-form-container {
    flex-direction: column;
  }
  .flex-container.investment-form-container .second-column,
  .flex-container.investment-form-container .first-column {
    width: 100%;
  }
}
.pl-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.pl-page--dialog {
  background: transparent;
  min-height: unset;
}
.pl-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.pl-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pl-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.pl-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.pl-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.pl-dlg-title {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px 8px !important;
}
.pl-dlg-title__left {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
}
.pl-import-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 16px 0;
  padding: 8px 12px;
  background: rgba(227, 253, 100, 0.08);
  border: 1px solid rgba(227, 253, 100, 0.25);
  border-radius: 8px;
  font-size: 0.8rem;
  color: var(--cf-text, #1a1d23);
}
.pl-import-notice mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: var(--cf-brand, #e3fd64);
}
.pl-btn-save {
  margin-left: auto;
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.pl-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.pl-body {
  padding: 14px 20px;
  flex: 1;
}
.pl-body--dialog {
  padding: 8px 16px;
}
.pl-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 900px) {
  .pl-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .pl-body {
    padding: 10px 12px;
  }
  .pl-header {
    padding: 10px 14px;
  }
}
.pl-section {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  overflow: hidden;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
  margin-bottom: 16px;
}
.pl-section:last-child {
  margin-bottom: 0;
}
.pl-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.pl-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.pl-section__body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.pl-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
@media (max-width: 500px) {
  .pl-two-col {
    grid-template-columns: 1fr;
  }
}
.pl-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 18px;
}
.pl-loading__icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--cf-brand, #e3fd64);
  opacity: 0.6;
}
.pl-loading__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--cf-text-muted, #6b7280);
}
::ng-deep .pl-page .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .pl-page .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
/*# sourceMappingURL=prestamos.component.css.map */
